<div class="billing-cycle-modal">
  <h1 mat-dialog-title>Edit Billing Cycle</h1>

  <div mat-dialog-content>
    <form [formGroup]="form">
      <app-billing-cycle-form
        [billingCycles]="data.billingCycles"
        [billingCycleControl]="billingCycleControl"
        [billingDayControl]="billingDayControl"
      ></app-billing-cycle-form>
    </form>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      color="warn"
      (click)="resetToDefault()"
      [disabled]="!data.billingCycleInfo?.billingCycleId"
    >
      Reset to Default
    </button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!form.valid">
      Save
    </button>
  </div>
</div>
